import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import * as fromRoot from '../../../reducers';
import { Language } from '../../models/language';

@Component({
    selector: 'dmv-pub-language-selector',
    templateUrl: './language-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LanguageSelectorComponent implements OnInit {
    public languages: Language[];
    public selectedLanguage: Language;

    public currentRoute$: Observable<string>;

    constructor(private rootStore: Store<fromRoot.State>, private translate: TranslateService) {
        this.currentRoute$ = this.rootStore.pipe(select(fromRoot.getCurrentRoute));
    }

    public ngOnInit(): void {
        this.languages = this.translate.getLangs().map<Language>(l => ({ value: l, display: l.toUpperCase() }));
        this.selectedLanguage = this.languages.find(l => l.value === this.translate.currentLang);
    }
}
